module.exports = __webpack_public_path__ + "static/media/dev_sharma_ji_1.5257ff94.jpg";